"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const helpers_1 = require("../../commonFiles/helpers");
const URLs_1 = require("../utility/URLs");
function PagesTable(props) {
    const pages = props.pages;
    const deletePage = props.deletePage;
    function hasArticles(Obj, Or = null) {
        var _a;
        if (pages)
            return ((_a = pages[0]) === null || _a === void 0 ? void 0 : _a.articles) ? Obj : Or;
    }
    function hasBooks(Obj, Or = null) {
        var _a;
        if (pages)
            return ((_a = pages[0]) === null || _a === void 0 ? void 0 : _a.books) ? Obj : Or;
    }
    function hasIsTrasnalted(Obj, Or = null) {
        var _a;
        if (pages)
            return ((_a = pages[0]) === null || _a === void 0 ? void 0 : _a.isTranslated) != undefined ? Obj : Or;
    }
    function hasBook(Obj, Or = null) {
        var _a;
        if (pages)
            return ((_a = pages[0]) === null || _a === void 0 ? void 0 : _a.book) ? Obj : Or;
    }
    return (react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, responsive: true },
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("th", null, "#"),
                react_1.default.createElement("th", null, "\u0627\u0644\u0639\u0646\u0648\u0627\u0646"),
                hasArticles(react_1.default.createElement("th", null, "\u0645\u0642\u0627\u0644\u0627\u062A")),
                react_1.default.createElement("th", null, "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0646 \u0627\u0644\u0635\u0641\u062D\u0629"),
                react_1.default.createElement("th", null, "\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0635\u062F\u0631"),
                hasBooks(react_1.default.createElement("th", null, "\u0643\u062A\u0628 \u062A\u0633\u062A\u0639\u0645\u0644 \u0627\u0644\u0635\u0641\u062D\u0629")),
                hasIsTrasnalted(react_1.default.createElement("th", null, "\u0645\u062A\u0631\u062D\u0645\u0629\u061F")),
                react_1.default.createElement("th", null, "book_id"),
                react_1.default.createElement("th", null))),
        react_1.default.createElement("tbody", null, pages === null || pages === void 0 ? void 0 : pages.map((page, index) => {
            var _a, _b, _c;
            return (react_1.default.createElement("tr", { key: index },
                react_1.default.createElement("td", null,
                    react_1.default.createElement(react_router_dom_1.Link, { to: URLs_1.Routes.pageShow(page.id) }, page.id)),
                react_1.default.createElement("td", null, page.title),
                hasArticles(react_1.default.createElement("td", null, (_a = page.articles) === null || _a === void 0 ? void 0 : _a.map((article, index) => article.title))),
                react_1.default.createElement("td", null, (0, helpers_1.truncate)(page.about, 30)),
                react_1.default.createElement("td", null, (0, helpers_1.truncate)(page.source_url, 30)),
                hasBooks(react_1.default.createElement("td", null, (_b = page.books) === null || _b === void 0 ? void 0 : _b.map((book, index) => (react_1.default.createElement(react_router_dom_1.Link, { key: index, to: URLs_1.Routes.bookShow(book.id) }, book.title))))),
                hasIsTrasnalted(react_1.default.createElement("td", null, page.isTranslated ? 'مترجمة' : 'غير مترجمة')),
                react_1.default.createElement("td", null, hasBook(react_1.default.createElement(react_router_dom_1.Link, { to: URLs_1.Routes.bookShow(page.book_id) }, (_c = page.book) === null || _c === void 0 ? void 0 : _c.title), react_1.default.createElement(react_router_dom_1.Link, { to: URLs_1.Routes.bookShow(page.book_id) }, page.book_id))),
                react_1.default.createElement("td", { onClick: () => confirm('are you sure?') ? deletePage(page.id) : null }, "\u062D\u062F\u0641")));
        }))));
}
exports.default = PagesTable;
